export const mobileBreakPoint = 375;
export const tabletSmallBreakpoint = 768;
export const tabletLargeBreakpoint = 1200;
